import { objectWithoutProperties as _objectWithoutProperties } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
var Star = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "32"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h32v32H1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#233034",
    strokeLinecap: "square",
    d: "M21.658 10.994l10.416 1.514-7.537 7.347 1.779 10.374L17 25.331l-9.316 4.898 1.779-10.374-7.537-7.347 10.416-1.514L17 1.555l4.658 9.439z"
  })));
});

export default Star;
//# sourceMappingURL=star.svg.js.map
